<app-loading *ngIf="isLoading"></app-loading>
<section class="clinic-services-page" style="margin-bottom: 150px;">

  <div class="clinic-header">
    <div>

      <h1>
        {{ isAr ? "خدمات العيادة" : "Clinic Services" }}
      </h1>
           <p class="clinic-subtitle">
               {{ "clinicaddresstitle" | transloco }}
         <br>
         {{ "clinicaddress" | transloco }} </p>

    </div>
  </div>

  @if(isLoading) {
    <div class="services-grid">
      @for(item of [1,2,3,4,5,6]; track item) {
        <div class="service-skeleton"></div>
      }
    </div>
  } @else {

    @if(services.length > 0) {
      <div class="services-grid">
        @for(service of services; track service.id) {

          <div (click)="serviceDetails(service)">
            <div class="product-card" [class.product-card-mobile]="isMobile">

              @if(calcDis(getServicePrice(service), service.pricec) !== 0) {
                <div class="discount-badge">
                  {{ calcDis(getServicePrice(service), service.pricec) }}%
                  {{ "discount" | transloco }}
                </div>
              }

              <div class="service-type-badge">
                {{ isAr ? "خدمة عيادة" : "Clinic Service" }}
              </div>

              <div class="product-visual">
                <div class="product-circle"></div>
                <div class="product-circle-dots"></div>

                <div class="product-img" [class.product-img-mobile]="isMobile">
                  @if(service.image) {
                    <img
                      [defaultImage]="'/assets/imageloading.gif'"
                      [lazyLoad]="fixImage(service.image)"
                      [errorImage]="getFallbackImage(service)"
                      alt="clinic service"
                    />
                  } @else {
                    <img [src]="getFallbackImage(service)" alt="clinic service">
                  }
                </div>
              </div>

              <div class="product-info">

                <p class="product-name" [class.product-name-mobile]="isMobile">
                  {{ isAr ? service.name_ar : service.name_en }}
                </p>

                <div class="price-row">
                  <span class="new-price" [class.new-price-mobile]="isMobile">
                    {{ getServicePrice(service) }}
                    {{ "egpe" | transloco }}
                  </span>

                  @if(calcDis(getServicePrice(service), service.pricec) !== 0) {
                    <span class="old-price">
                      {{ service.pricec }} {{ "egpe" | transloco }}
                    </span>
                  }
                </div>

                <button
                  class="btn btn-add"
[routerLink]="['/book', service?.id]"                  
                  (click)="$event.stopPropagation()"
                >
                  {{ isAr ? "احجز" : "Book Service" }}
                </button>

              </div>

            </div>
          </div>

        }
      </div>


    } @else {
      <div class="empty-state">
        <img src="/assets/noproduct.png" alt="empty">
        <h3>
          {{ isAr ? "لا توجد خدمات متاحة حالياً" : "No services available now" }}
        </h3>
      </div>
    }

  }

</section>